import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
import { clearUserData, getNewStateById } from './entities';
import { applyPagedPreFetchState, applyPagedState, getOffsetAndLimit } from './utils/pagination';
const RESULTS_PER_PAGE = 20;
const initialState = {
    byId: {},
    byPage: {},
    hasNextPage: false,
    page: 0,
    status: 'init'
};
export const fetchTransactionsNextPage = createAsyncThunk('transactions/fetch/nextPage', async (props, thunkApi) => {
    const { transactions } = thunkApi.getState();
    const { page: currentPage = 0 } = transactions;
    const nextPage = currentPage + 1;
    const options = {
        limit: RESULTS_PER_PAGE,
        offset: RESULTS_PER_PAGE * (nextPage - 1)
    };
    try {
        return await (await api.instance).fetchTransactions(options);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const fetchTransactionsPage = createAsyncThunk('transactions/fetch/page', async (nextPage, thunkApi) => {
    const options = getOffsetAndLimit(nextPage, RESULTS_PER_PAGE);
    try {
        return await (await api.instance).fetchTransactions(options);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
const transactionsSlice = createSlice({
    name: 'transactions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(clearUserData.fulfilled, (state) => (state = initialState))
            .addCase(fetchTransactionsNextPage.fulfilled, (state, action) => {
            state.byId = getNewStateById(state.byId, action.payload);
            const previousPage = state.page;
            applyPagedState(state, action.payload, previousPage + 1, RESULTS_PER_PAGE);
            state.status = 'success';
        })
            .addCase(fetchTransactionsPage.fulfilled, (state, action) => {
            const page = action.meta.arg;
            state.byId = getNewStateById(state.byId, action.payload);
            applyPagedState(state, action.payload, page, RESULTS_PER_PAGE);
            state.status = 'success';
        })
            .addCase(fetchTransactionsNextPage.pending, (state) => {
            applyPagedPreFetchState(state);
            state.status = 'fetching';
        })
            .addCase(fetchTransactionsPage.pending, (state, action) => {
            applyPagedPreFetchState(state);
            state.status = 'fetching';
        })
            .addCase(fetchTransactionsNextPage.rejected, (state) => {
            state.status = 'error';
        })
            .addCase(fetchTransactionsPage.rejected, (state) => {
            state.status = 'error';
        });
    }
});
export const transactionsReducer = transactionsSlice.reducer;
